import { Input } from 'antd'

export const SearchInput = ({ size = 'small', ...props }: React.ComponentProps<typeof Input.Search>) => (
  <Input.Search placeholder="Suchen..." allowClear size={size} {...props} />
)
